import styles from './contact-us-link.module.scss';

export interface Props {
  subject?: string;
}

const ContactUsLink = ({ subject }: Props) => (
  <a
    className={styles.container}
    href={`mailto:alex@youth-app.com${
      subject == null ? '' : `?subject=${encodeURIComponent(subject)}`
    }`}
  >
    contact us
  </a>
);

export default ContactUsLink;
